import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
  },
  sectionLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.75),
    padding: theme.spacing(1, 3),
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.default,
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  sectionRule: {
    flex: 1,
    height: 1,
    backgroundColor: theme.palette.divider,
  },
}))

export default useStyles
